<div>
  <div class="gb-dialog-header">
    <h1>{{ 'USERS.INVITE_DIALOG.TITLE' | translate }}</h1>

    <button mat-icon-button mat-dialog-close>
      <gb-icon icon="close"></gb-icon>
    </button>
  </div>

  <div class="gb-dialog-content message-user-dialog-content">
    <p translate="USERS.INVITE_DIALOG.BODY"></p>

    <form [formGroup]="inviteUserForm">
      @for (identity of identities; track identity; let i = $index) {
        <div class="add-field">
          <div class="invite-field-row">
            <div class="input-fields">
              @if (identity.identityType === userIdentityTypeEnum.Email) {
                <gb-form-field
                  [control]="getControl(i)"
                  type="email"
                  labelTranslateKey="USERS.CREATE_USER.EMAIL"
                ></gb-form-field>
              }
              @if (identity.identityType === userIdentityTypeEnum.Mobile) {
                <mat-form-field>
                  <mat-label translate="PHONE_INPUT_LABEL"> </mat-label>
                  <gb-intl-phone-input
                    [formControl]="getControl(i)"
                    name="phone_number"
                    [auctionCountryCode]="(auction$ | async)?.country"
                  ></gb-intl-phone-input>
                </mat-form-field>
              }
              @if (isBothEmailPhoneAllowed$ | async) {
                <div class="identity-changer">
                  <a class="link mat-body-1" (click)="toggleIdentityType(i)">
                    {{ getLinkTranslate(identity.identityType) | translate }}
                  </a>
                </div>
              }
            </div>
            <div class="button-container">
              @if (i > 0) {
                <button (click)="deleteField(i)" type="button" mat-stroked-button>
                  <gb-icon icon="trash"></gb-icon>
                </button>
              }
            </div>
          </div>
        </div>
      }
    </form>

    @if (identities.length < 11) {
      <button mat-stroked-button class="add-field-button" (click)="addField()">
        <gb-icon icon="add"></gb-icon>
      </button>
    }
  </div>
  <div class="gb-dialog-actions-container">
    <button mat-flat-button (click)="submitForm()" [disabled]="(inviteLoaded$ | async) === false">
      <gb-button-loader [loaded$]="inviteLoaded$">
        <span>{{ 'SUBMIT' | translate }}</span>
      </gb-button-loader>
    </button>
  </div>
</div>
